import React from "react";

import { ErrorsCallback, SuccessCallback,WarningCallback,QuestionCallback } from "alertService"
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Button from "components/CustomButtons/Button.jsx" 
import CustomInput from "components/CustomInput/CustomInput.jsx" 
import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx"; 
var W3CWebSocket = require('websocket').w3cwebsocket;
var client = new W3CWebSocket('ws://127.0.0.1:8748/QAgent'); 
class PageTestPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataSelect:null,
      data:"{}", 
      currentTel:"",
      isCalling:false
    }
  }
  componentDidMount(){   
    // ของเดิม >>>>> รหัส 1630
    // websocket.onopen = function(evt) { websocket.send("dial|" + qagentNo + telNo + "|Test"); };
    // websocket.onopen = function(evt) { websocket.send("hangup"); }; 

    this.onConnectingQAgent()

  }
  onConnectingQAgent() {
    client = new W3CWebSocket('ws://127.0.0.1:8748/QAgent'); 
    client.onerror = (e)=> {
      console.log('Connection Error');
      this.setState({QAgantAllready:false})
    }; 
    client.onopen = ()=> {
        console.log('WebSocket Client Connected'); 
        this.setState({QAgantAllready:true})
    };
    client.onclose = ()=> {
      console.log('Client Closed. Waiting 2 sec for reconnecting.');
      setTimeout(()=>{
          console.log('Client reconnecting...'); 
          this.onConnectingQAgent()
      },2000); 
    };
    client.onmessage = (e)=> {   
      if (typeof e.data === 'string') {
        const res = JSON.parse(e.data); 
        console.log("Received message : '" + res.message + "'"); 
      }
    };
  }
  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };
  onStartCall = () =>{
    if(!this.state.currentTel){
      ErrorsCallback("ไม่สามารถโทรออกได้เนื่องจากไม่พบเบอร์ลูกค้า" )
      return
    } 
    if(this.state.currentTel.length != 10){
      ErrorsCallback("ไม่สามารถโทรออกได้เนื่องจากเบอร์โทรลูกค้าไม่ถูกต้อง" )
      return
    } 
    this.setState({isCalling:true},()=>{ 
      console.log("dial|88" + this.state.currentTel + "|Nissan_BP20"); 
      client.send("dial|88" + this.state.currentTel + "|Nissan_BP20");
    })
  }
  onStopCall = () =>{
    this.setState({isCalling:false},()=>{
      console.log("Stop Calling : " + this.state.currentTel);
      client.send("hangup");
    })
  }
  
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={11}>
            <Card testimonial>
              <div>
                <h1>Test Calling</h1>
              </div>
              <div className="tel-input">
                <CustomInput 
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    rows:1,
                    multiline :true, 
                    type: "text",
                    value: this.state.currentTel,
                    placeholder: "ระบุเบอร์ (10 หลัก)",
                    onChange: e => this.handleChange("currentTel",e.target.value) 
                  }}
                />
              </div>
              {
                (!this.state.isCalling)?
                  <Button
                    color = "info"
                    round 
                    onClick = { e=> this.onStartCall()}
                  >
                    Call Now!
                  </Button>
                :
                <Button
                  color = "danger"
                  round 
                  onClick = { e=> this.onStopCall()}
                >
                  Call Stop!
                </Button>
              } 
              <CardBody> 
                {/* {this.state.data}   */}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(PageTestPage);
